"use client";

import type { OutputLanguage } from "@/types/aicheck";

export const RESULTS_PREFIX = "aicheck:results:";
export const CHECKPOINT_PREFIX = "aicheck:checkpoint:v1:";
export const HISTORY_KEY = "aicheck:history";
export const CACHE_INVENTORY_KEY = "aicheck:cache-inventory:v1";
export const GRAPH_EXPANDED_PREFIX = "aicheck:graph-expanded:";
export const CONTACT_TOPICS_PREFIX = "aicheck:contact_topics:";
export const DISMISSED_PREFIX = "aicheck:dismissed:";
export const PROJECT_DATA_SOURCE_PREFIX = "aicheck:project-data-source:";
export const MERGE_CHECK_RESULT_PREFIX = "aicheck:merge-check-result:";

export const RESULTS_CACHE_VERSION = 10;
export const CONTACT_TOPICS_VERSION = 1;
export const PROJECT_DATA_SOURCE_CACHE_VERSION = 3;
export const MERGE_CHECK_RESULT_CACHE_VERSION = 2;
export const CACHE_INVENTORY_VERSION = 4;
export const MAX_HISTORY = 50;
export const MAX_RECENT_EVICTIONS = 10;
export const ALL_LANGUAGES: OutputLanguage[] = ["en", "ja"];

export function getResultCacheKey(
  projectId: number,
  language: OutputLanguage,
): string {
  return `${RESULTS_PREFIX}${projectId}:${language}`;
}

export function getCheckpointCacheKey(
  projectId: number,
  language: OutputLanguage,
): string {
  return `${CHECKPOINT_PREFIX}${projectId}:${language}`;
}

export function getGraphExpandedKey(projectId: number): string {
  return `${GRAPH_EXPANDED_PREFIX}${projectId}`;
}

export function getContactTopicsKey(projectId: number): string {
  return `${CONTACT_TOPICS_PREFIX}${projectId}`;
}

export function getDismissedKey(projectId: number): string {
  return `${DISMISSED_PREFIX}${projectId}`;
}

export function getProjectDataSourceCacheKey(sourceKey: string): string {
  return `${PROJECT_DATA_SOURCE_PREFIX}${sourceKey}`;
}

export function getMergeCheckResultCacheKey(mergeCacheKey: string): string {
  return `${MERGE_CHECK_RESULT_PREFIX}${mergeCacheKey}`;
}
